import { Handle, Position } from '@xyflow/react'
import { selectedBorder } from '../selectedBorder.js'

export function RuleNotNode({ selected }) {
  return (
    <div style={{
      background: selected ? '#2a1a1a' : '#1a1212',
      border: `2px solid ${selected ? selectedBorder('#703030') : '#703030'}`,
      borderRadius: 20,
      padding: '8px 20px',
      color: '#d08080',
      fontFamily: 'var(--m-font)',
      fontSize: 13,
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
      display: 'flex',
      alignItems: 'center',
      gap: 6,
    }}>
      <Handle
        type="target"
        position={Position.Left}
        id="in"
        style={{ background: '#c04040', width: 10, height: 10 }}
      />
      NOT
      <Handle
        type="source"
        position={Position.Right}
        id="out"
        style={{ background: '#c04040', width: 10, height: 10 }}
      />
    </div>
  )
}
